import * as Yup from "yup";
import eightAxios from "configs/axiosConfig";
import React, { useEffect, useState } from "react";

import Form from "@Components/Form";
import { SMTP_URL, URLS } from "configs/constants";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { useNotifyContext } from "@Components/Notify";
import { useHistory } from "react-router-dom";

const initialValues = {
  email_host: "",
  email_host_user: "",
  email_host_password: "",
  email_port: "",
  email_sender: "",
};

function EmailSmtpForm() {
  const [loading, setLoading] = useState(false);
  const [valuesFromApi, setValuesFromApi] = useState(null);
  const setNotify = useNotifyContext();
  const history = useHistory();

  const validationSchema = Yup.object({
    email_host: Yup.string().required("Email host is required"),
    email_host_user: Yup.string().required("Email host user is required"),
    email_host_password: Yup.string().required(
      "Email host password is required"
    ),
    email_port: Yup.string().required("Email port is required"),
    email_sender: Yup.string().required("Email sender is required"),
  });

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(SMTP_URL)
      .then((response) => {
        if (response.data.results.length > 0) {
          setValuesFromApi(response.data.results[0]);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    setLoading(true);
    eightAxios
      .post(SMTP_URL, values)
      .then(() => {
        setValuesFromApi(values);
        setNotify({
          isOpen: true,
          message: "Successfully updated.",
          type: "success",
        });
        setLoading(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
        setLoading(false);
      });
  };

  const formFields = [
    {
      type: "input",
      variant: "outlined",
      autoComplete: "off",
      name: "email_host",
      size: "small",
      label: "Host",
      required: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 9 },
    },
    {
      type: "input",
      variant: "outlined",
      autoComplete: "off",
      name: "email_host_user",
      size: "small",
      label: "Host user",
      required: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 9 },
    },
    {
      type: "input",
      variant: "outlined",
      autoComplete: "off",
      name: "email_host_password",
      size: "small",
      password: true,
      label: "Host Password",
      required: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 9 },
    },
    {
      type: "input",
      variant: "outlined",
      autoComplete: "off",
      name: "email_port",
      size: "small",
      label: "Port",
      required: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 9 },
    },
    {
      type: "input",
      variant: "outlined",
      autoComplete: "off",
      name: "email_sender",
      size: "small",
      label: "Sender",
      required: true,
      gridSize: { xs: 12, sm: 8, md: 9, lg: 9 },
    },
  ];

  const formButtons = [
    "submit",
    {
      label: "Cancel",
      renderValue: "Closed",
      onClick: () => {
        history.push(URLS.DASHBOARD);
      },
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <Form
      initialValues={valuesFromApi ? valuesFromApi : initialValues}
      outerSubmitHandler={handleSubmit}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="SMTP Config"
      validationSchema={validationSchema}
      noListButton
    />
  );
}

export default EmailSmtpForm;
